import { Pipe, PipeTransform } from '@angular/core';
const zabbixUtil = require('../../../../../noc/monitoring/pages/alarm/zabbix-util');

@Pipe({
  name: 'trainSyncStatusColor'
})
export class TrainSyncStatusColorPipe implements PipeTransform {

  transform(level: number): unknown {
    return {
      'background-color': zabbixUtil.getPriorityColor(level)
    }
  }

}
